import { render, staticRenderFns } from "./TheLayoutToTopFab.vue?vue&type=template&id=155b1c5f&"
import script from "./TheLayoutToTopFab.vue?vue&type=script&lang=js&"
export * from "./TheLayoutToTopFab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports